export const sizes = {
  navHeight: '70px',
  navHeightMobile: '45px',
  tabHeight: '35px',
  tabHeightMobile: '51px',
  breadcrumbsHeight: '60px',
};

export default sizes;
